// extracted by mini-css-extract-plugin
export default {"icon":"Loading_icon__pnhQo","rotation":"Loading_rotation__Iuvqs","mainDiv":"Loading_mainDiv__SC5GB","message":"Loading_message__ib-Wi"};